import React from 'react';
import './receiptPrint.css';
import bahtText from 'thai-baht-text';

// --- Sub-component to render a single receipt (original or copy) ---
const SingleOfficeReceipt = ({ receiptData, title }) => {

  // Function to format date to Thai Buddhist year (DD Mon. YY+543)
  const formatDateToThai = (isoDateString) => {
    if (!isoDateString) return '';
    const date = new Date(isoDateString);
    if (isNaN(date.getTime())) return ''; // Return empty string if date is invalid
    const day = date.getDate();
    const monthNamesThai = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    const month = monthNamesThai[date.getMonth()];
    const year = date.getFullYear() + 543; // Buddhist year
    return `${day} ${month} ${String(year).slice(-2)}`; // Last two digits of Buddhist year
  };

  // Tab variables for consistent spacing
  const tab1 = '\u00a0\u00a0\u00a0\u00a0\u00a0';
  const tab2 = `${tab1}${tab1}`;
  const tab3 = `${tab2}${tab1}`;
  const indentForNotes = tab2 + '\u00a0\u00a0\u00a0';

  // Sanitize numbers by removing commas before parsing
  const tuitionFee = parseFloat(String(receiptData['รวม'] || '0').replace(/,/g, ''));
  const discount = parseFloat(String(receiptData['หักส่วนลด'] || '0').replace(/,/g, ''));

  // Recalculate the total directly in the print component to ensure accuracy
  const totalAmount = tuitionFee - discount;

  // ตรวจสอบว่ามีข้อมูล 'วันเริ่มคอร์ส' หรือไม่
  // ถ้ามี ให้แปลงวันที่ ถ้าไม่มี ให้แสดงคำว่า 'ชำระล่วงหน้า'
  const startDateDisplay = receiptData['วันเริ่มคอร์ส']
    ? formatDateToThai(receiptData['วันเริ่มคอร์ส'])
    : 'ชำระล่วงหน้า';


  return (
    <div className="receipt-print-container office-receipt-print">
      {/* --- HEADER SECTION --- */}
      <div className="receipt-header">
        <div className="receipt-address">
          <p>สถาบันพาวร์เวอร์วิสดอม</p>
          <p>32/514 ถ.ประชาอุทิศ แขวงทุ่งครุ เขตทุ่งครุ</p>
          <p>กรุงเทพฯ 10140 โทร. 093-2293959</p>
          <p><a href="https://www.power-wisdom.com">www.power-wisdom.com</a></p>
        </div>
        <div className="receipt-logo">
          <img src="/Wisdom-Logo.png" alt="Power Wisdom Logo" style={{ height: '50px' }} />
        </div>
      </div>

      <div className="receipt-title-row">
        <p className="receipt-title-school">{title}</p>
        <div className="receipt-info-box-school">
          <div className="info-row">
            <span>เลขที่</span>
            <span className="info-value">{receiptData['หมายเลขใบเสร็จ']}</span>
          </div>
          <div className="info-row">
            <span>วันที่</span>
            <span className="info-value">{formatDateToThai(receiptData['วันที่'])}</span>
          </div>
        </div>
      </div>
      {/* --- END OF HEADER SECTION --- */}

      <div className="receipt-details">
        <div className="detail-row">
          <span className="label">ได้รับเงินจาก</span>
          <span className="value">
            {`${receiptData['เพศ']} ${receiptData['ชื่อ']} ${receiptData['นามสกุล']}`}
            {`\u00a0\u00a0\u00a0\u00a0`}
            {`(${receiptData['ชื่อเล่น']})`}
          </span>
        </div>
      </div>

      <table className="receipt-table">
        <thead>
          <tr>
            <th style={{ width: '80%' }}>รายการ</th>
            <th style={{ width: '20%' }}>จำนวนเงิน</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p style={{ margin: 0 }}>{`${tab1}ค่าเรียน`}</p>
              <p style={{ margin: 0 }}>{`${tab3}${receiptData['Couse']}${tab1}ระดับ : ${receiptData['Level'] || ''}`}</p>
              <p style={{ margin: 0 }}>{`${tab3}วัน / รอบ : ${receiptData['วัน'] || ''}${tab2}เวลา : ${receiptData['เวลา'] || ''}`}</p>
              <p style={{ margin: 0 }}>{`${tab3}วันเริ่มคอร์ส : ${startDateDisplay}${tab2}วันจบคอร์ส :${tab1}${receiptData['วันจบคอร์ส']}`}</p>
            </td>
            <td className="amount">{tuitionFee.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
          </tr>
          {discount > 0 && (
            <tr className="plain-row">
              {/* --- START: EDIT THIS LINE --- */}
              <td>{`${tab1}หักส่วนลด :${tab1}${receiptData['หมายเหตุส่วนลด'] || ''}`}</td>
              {/* --- END: EDIT THIS LINE --- */}
              <td className="amount">
                {`-${discount.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
              </td>
            </tr>
          )}
          <tr className="total-row">
            <td className="total-word-cell">
              {`(${bahtText(Math.abs(totalAmount))})`}
            </td>
            <td className="amount total">
              {totalAmount.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </td>
          </tr>
        </tbody>
      </table>

      {/* --- FOOTER SECTION --- */}
      <div className="receipt-footer">
        <div className="footer-notes">
            <p>
                <span className="note-label">หมายเหตุ :</span>
                {indentForNotes}{receiptData['หมายเหตุ']}
            </p>
        </div>
        <div className="payment-info">
            <p>
                <span className="payment-label">วิธีการชำระ :</span>
                {tab2}{receiptData['จ่ายโดย']}
            </p>
        </div>

        <div className="recipient-signature">
            <p>ผู้รับเงิน ..............................................................</p>
            <p>(นางปรัชภา อภิวุฒิกาญจนาภา){tab2}</p>
        </div>

        <div className="receipt-validation-box">
            <p>ใบเสร็จนี้ออกผ่านระบบออนไลน์ หากต้องการเอกสารสามารถขอรับเอกสารใบเสร็จได้ที่สถาบัน</p>
            <p>ระยะเวลาเรียน 10 ครั้งภายใน 14 สัปดาห์ นับจากวันที่เริ่มเรียนครั้งแรก</p>
        </div>
      </div>
      {/* --- END OF FOOTER SECTION --- */}
    </div>
  );
};


// --- Main component that gets exported ---
const OfficeReceiptPrint = ({ receiptData }) => {
    if (!receiptData) return null;

    return (
        <>
            {/* Render the original receipt */}
            <SingleOfficeReceipt receiptData={receiptData} title="ใบเสร็จรับเงิน" />
            {/* Render the copy */}
            <SingleOfficeReceipt receiptData={receiptData} title="ใบเสร็จรับเงิน / สำเนา" />
        </>
    );
};


export default OfficeReceiptPrint;